export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["货币"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建报告"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["货币结果"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下载"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["工作表"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["允许的文件格式 - xlsx"])}
}